// extracted by mini-css-extract-plugin
module.exports =  {"icon":"d30e7684c4--icon--pQVGs"};